import createIcon from "./createIcon";

export const VipLogoLightIcon = createIcon('VipLogoLight', (props) => {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none">
      <defs>
        {/* 修改1：移除不支持的effect标签，转换为标准filter */}
        <filter
          id="filter_9"
          width="21.295"
          height="10.678"
          x="22.859"
          y="8.207"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB" /* 修改2：属性改为驼峰式 */
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" mode="normal" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="0.159" dy="0.159" />
          <feGaussianBlur stdDeviation="0.053" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.251 0" />
          <feBlend in2="shape" result="effect_innerShadow_1" mode="normal" />
        </filter>

        {/* 修改3：stop-color改为stopColor，stop-opacity改为stopOpacity */}
        <linearGradient id="paint_linear_11" x1="21.295" x2="0" y1="5.339" y2="5.339" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(207,188,158)" offset="0" stopOpacity="1" />
          <stop stopColor="rgb(163,140,107)" offset="0.417" stopOpacity="1" />
          <stop stopColor="rgb(202,180,145)" offset="0.665" stopOpacity="1" />
          <stop stopColor="rgb(173,150,117)" offset="0.874" stopOpacity="1" />
        </linearGradient>

        {/* 修改4：移除不支持的effect标签，转换为标准filter */}
        <filter
          id="filter_10"
          width="14.604"
          height="8.696"
          x="2.986"
          y="10.559"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" mode="normal" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="-0.159" dy="0.159" />
          <feGaussianBlur stdDeviation="0.106" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.506 0" />
          <feBlend in2="shape" result="effect_innerShadow_1" mode="normal" />
        </filter>

        <linearGradient id="paint_linear_12" x1="10.288" x2="10.288" y1="10.559" y2="29.348" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(255,243,224)" offset="0.001" stopOpacity="1" />
          <stop stopColor="rgb(240,225,203)" offset="0.384" stopOpacity="1" />
          <stop stopColor="rgb(202,180,145)" offset="0.665" stopOpacity="1" />
          <stop stopColor="rgb(173,150,117)" offset="0.874" stopOpacity="1" />
        </linearGradient>

        {/* 修改5：移除不支持的effect标签，转换为标准filter */}
        <filter
          id="filter_11"
          width="19.768"
          height="10.281"
          x="0"
          y="1"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" mode="normal" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="-0.159" dy="0.159" />
          <feGaussianBlur stdDeviation="0.106" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.506 0" />
          <feBlend in2="shape" result="effect_innerShadow_1" mode="normal" />
        </filter>

        <linearGradient id="paint_linear_13" x1="9.883" x2="9.883" y1="1" y2="23.212" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgb(255,243,224)" offset="0.001" stopOpacity="1" />
          <stop stopColor="rgb(240,225,203)" offset="0.384" stopOpacity="1" />
          <stop stopColor="rgb(202,180,145)" offset="0.665" stopOpacity="1" />
          <stop stopColor="rgb(173,150,117)" offset="0.874" stopOpacity="1" />
        </linearGradient>
      </defs>

      {/* 修改6：fill-rule改为fillRule */}
      <rect id="logo" width="20" height="20" x="0" y="0" fill="none" />

      <g filter="url(#filter_9)">
        <path
          id="路径_189" /* 修改7：中文ID改为兼容性更好的格式 */
          d="M3.66081 10.6777L8.63721 10.6777C10.0282 10.6777 11.3608 10.1185 12.3353 9.12592L19.0516 2.28485C19.886 1.43494 19.2839 -2.79924e-07 18.0929 -2.79924e-07L12.9395 0C11.5762 0 10.2679 0.537156 9.29793 1.49508L2.60469 8.10528C1.64875 9.04937 2.31726 10.6777 3.66081 10.6777Z"
          opacity="0"
          fill="url(#paint_linear_11)"
          style={{ mixBlendMode: 'multiply' }} /* 修改8：React样式对象写法 */
          fillRule="evenodd"
          transform="matrix(-1,0,0,1,44.1543,8.20654)"
        />
      </g>

      <g id="组合_169"> {/* 修改9：中文ID改为兼容性更好的格式 */}
        <g style={{ mixBlendMode: 'normal' }}>
          <g filter="url(#filter_10)">
            <path
              id="减去顶层"
              d="M2.98633 11.5722L8.6825 11.5722C9.47894 11.5722 10.2491 11.2873 10.8538 10.769L11.0987 10.5591L17.1792 16.7637C18.0594 17.6618 17.4351 19.1769 16.1777 19.1943L11.7726 19.255C10.8933 19.2672 10.0482 18.9143 9.43861 18.2805L2.98633 11.5722Z"
              opacity="0.4"
              fill="url(#paint_linear_12)"
              fillRule="evenodd"
            />
          </g>
        </g>
        <g style={{ mixBlendMode: 'normal' }}>
          <g filter="url(#filter_11)">
            <path
              id="路径_243" /* 修改10：中文ID改为兼容性更好的格式 */
              d="M3.12416 11.2461L8.58006 11.1857C9.5872 11.1745 10.5476 10.759 11.2452 10.0325L17.8842 3.11923C18.601 2.37279 18.0839 1.1306 17.0492 1.11321L11.3634 1.01765C10.6923 1.00637 10.0451 1.26747 9.56971 1.74138L2.21276 9.07496C1.40528 9.87988 1.98409 11.2587 3.12416 11.2461Z"
              fill="url(#paint_linear_13)"
              fillRule="evenodd"
            />
          </g>
        </g>
      </g>
    </svg>
  );
});